import { useMemo } from 'react';
import type { Action } from 'types';

export interface GroupedItem {
  field: Record<'id', string>;
  index: number;
  outputValue: Action['externalRestApi']['outputValues'][0];
}

export interface UseExternalRestApiOutputContentGroupResult {
  groups: Record<string, GroupedItem[]>;
  ungrouped: GroupedItem[];
}

export const useExternalRestApiOutputContentGroup = (
  outputValuesFields: Record<'id', string>[],
  outputValues: Action['externalRestApi']['outputValues']
): UseExternalRestApiOutputContentGroupResult => {
  return useMemo(() => {
    const groups: Record<string, GroupedItem[]> = {};
    const ungrouped: GroupedItem[] = [];

    outputValuesFields.forEach((field, index) => {
      const outputValue = outputValues[index] || {};
      const item: GroupedItem = { field, index, outputValue };

      if (outputValue.groupId) {
        if (!groups[outputValue.groupId]) {
          groups[outputValue.groupId] = [];
        }
        groups[outputValue.groupId].push(item);
      } else {
        ungrouped.push(item);
      }
    });

    return { groups, ungrouped };
  }, [outputValuesFields, outputValues]);
};
